import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Autocomplete,
  Stack,
  IconButton,
  Tabs,
  Tab,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { DataGrid } from "@mui/x-data-grid";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { CommonDeleteButton, CommonEditButton, DeletePopup, ToolsFieldWithMic } from "../../../Components/Common Components/CommonComponents";
import { ImagePaths } from "../../../Utility/ImagePaths";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import { Expiry_period } from "../../../Utility/Constants";
import { Colors } from "../../../Styles/Colors";
import Loader from "../../../Components/Loader";
import { AmountFormat, ContentInTooltip } from "../../../Components/CommonFunctions/CommonFunctions";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTime } from "luxon";

const StorePurchaseInwardAdd = () => {
  const topDivRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [productTab, setProductTab] = useState('product');
  const [vendorMappList, setvendorMappList] = useState([]);
  const [vendorList, setvendorList] = useState([]);
  const [categoryList, setcategoryList] = useState([]);
  const [subCategoryList, setsubCategoryList] = useState([]);
  const [departmentList, setdepartmentList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [errorMsg, seterrorMsg] = useState(false);
  const [errorMsgText, seterrorMsgText] = useState('');
  const [successMsg, setsuccessMsg] = useState(false);
  const [successMsgText, setsuccessMsgText] = useState('');
  const [PurchaseInwardData, setPurchaseInwardData] = useState([]);
  const [StockItemData, setStockItemData] = useState([]);
  const [EditID, setEditID] = useState(null);
  const [PiLineEditID, setpiLineEditID] = useState(null);
  const [inwardId, setInwardId] = useState(null);
  const [isloader, setisloader] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);
  const [type_Paisa, setType_Paisa] = useState(true);

  const [vendorFormData, setVendorFormData] = useState({
    vendor_details: null,
    bill_date: new Date(),
    bill_number: "",
    delivery_date: new Date(),
    total_amount: "",
    cgst: "",
    sgst: "",
    tcs: "",
    bill_amount: "",
    paisa: "",
    round_off: "",
  });

  const [formData, setformData] = useState({
    product_details: null,
    product_code: "",
    department_details: null,
    category_details: null,
    sub_category_details: null,
    product_type_details: null,
    modelSerialNo: "",
    hsnCode: "",
    batchNo: "",
    stock_in_quantity: "",
    quantity: "",
    noOfUnits: "",
    buyingPrice: "",
    freeQuantity: "",
    discountPercentage: "",
    discountAmount: "",
    gstPercentage: "",
    mrp: "",
    expiryAlert: null,
    expiryDate: null,
    reorderThreshold: "",
    manufactureName: "",
    physicalBoxNo: "",
    new_batch: false
  });

  const [otherDeatils, setOtherDetails] = useState("");
  const [postBtnDisble, setPostBtnDisble] = useState(false);

  useEffect(() => {
    if (postBtnDisble) {
      postPurchaseInward(postBtnDisble === "Finish Grn")
    }
  }, [postBtnDisble])

  const columns = [
    {
      field: "product_name", headerName: "Product Details", flex: 0.30,
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
          {ContentInTooltip(params?.row?.product_name, 40, "0.8vw", 600)}
          {ContentInTooltip(params?.row?.product_code, 40, "0.7vw", 500, 0, Colors.grayShade)}
          {ContentInTooltip(params?.row?.hsn_code, 40, "0.7vw", 500, 0, Colors.grayShade)}
          {ContentInTooltip(params?.row?.product_type_name, 40, "0.7vw", 500, 0, Colors.grayShade)}
        </Box>)
    },
    {
      field: "department_name", headerName: "Department", flex: 0.2,
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
          {ContentInTooltip(params?.row?.department_name, 40, "0.8vw", 500)}
          {ContentInTooltip(params?.row?.category_name, 40, "0.7vw", 500, 0, Colors.grayShade)}
          {ContentInTooltip(params?.row?.sub_category_name, 40, "0.7vw", 500, 0, Colors.grayShade)}
        </Box>)
    },
    {
      field: "batch_no", headerName: "Batch No", flex: 0.17,
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
          {ContentInTooltip(params?.row?.batch_no, 40, "0.8vw", 600)}
        </Box>)
    },
    {
      field: "stock_in_quantity", headerName: "Quantity", flex: 0.1, type: "number",
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
          <Typography fontSize={'0.8vw'}>{params?.row?.stock_in_quantity ? params?.row?.stock_in_quantity : 0}</Typography>
        </Box>)
    },
    {
      field: "free_quantity", headerName: "FQ", flex: 0.08, type: "number",
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
          <Typography fontSize={'0.8vw'}>{params?.row?.free_quantity ? params?.row?.free_quantity : 0}</Typography>
        </Box>)
    },
    {
      field: "no_of_units", headerName: "Units", flex: 0.08, type: "number",
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
          <Typography fontSize={'0.8vw'}>{params?.row?.no_of_units ? params?.row?.no_of_units : 0}</Typography>
        </Box>)
    },
    {
      field: "buying_quantity", headerName: "BP/U", flex: 0.11, type: "number",
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
          <Typography fontSize={'0.8vw'}>{params?.row?.buying_quantity ? AmountFormat(params?.row?.buying_quantity) : AmountFormat(0)}</Typography>
        </Box>)
    },
    {
      field: "mrp_quantity", headerName: "MRP/U", flex: 0.1, type: "number",
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
          <Typography fontSize={'0.8vw'}>{params?.row?.mrp_quantity ? AmountFormat(params?.row?.mrp_quantity) : "-"}</Typography>
        </Box>)
    },
    {
      field: "discount_amount", headerName: "Disc", flex: 0.1, type: "number",
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls' sx={{ textAlign: 'right' }}>
          <Typography fontSize={'0.8vw'}>{params?.row?.discount_percentage ? `${params?.row?.discount_percentage} %` : '0 %'}</Typography>
          <Typography fontSize={'0.8vw'}>{params?.row?.discount_amount ? AmountFormat(params?.row?.discount_amount) : AmountFormat(0)}</Typography>
        </Box>)
    },
    {
      field: "gst_amount", headerName: "GST", flex: 0.1, type: "number",
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls' sx={{ textAlign: 'right' }}>
          <Typography fontSize={'0.8vw'}>{params?.row?.gst_percentage ? `${params?.row?.gst_percentage} %` : '0 %'}</Typography>
          <Typography fontSize={'0.8vw'}>{params?.row?.gst_amount ? AmountFormat(params?.row?.gst_amount) : AmountFormat(0)}</Typography>
        </Box>)
    },
    {
      field: "net_amount", headerName: "Net Amt", flex: 0.15, type: "number",
      renderCell: (params) => (
        <Box component={'div'} emed_tid='emed_lab_rcpt_dtls'>
          <Typography fontSize={'0.8vw'}>{params?.row?.net_amount ? AmountFormat(Number(params?.row?.net_amount.toFixed(2))) : AmountFormat(0)}</Typography>
        </Box>)
    },
    {
      field: "action", headerName: "Action", flex: 0.13, align: "center",
      renderCell: (params) => (
        <Stack direction="row" alignItems="center" spacing={4}>
          {location.states?.bill_details?.is_finished ? null :
            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
              <CommonEditButton size="1.5vw" disable={params?.row?.from_stock} onClick={() => {
                let ProductData = productList?.find((item) => item?.id === (params.row.productID || params.row.product_id))
                setformData({
                  product_details: ProductData,
                  product_code: ProductData?.product_code,
                  department_details: params.row?.department_name,
                  category_details: params.row?.category_name,
                  sub_category_details: params.row?.sub_category_name,
                  product_type_details: params.row?.product_type_name,
                  modelSerialNo: ProductData?.model_no ? ProductData?.model_no : "",
                  hsnCode: params.row?.hsn_code ? params.row?.hsn_code : "",
                  batchNo: params.row.batch_no ? params.row.batch_no : "",
                  quantity: params.row.quantity ? params.row.quantity : "",
                  noOfUnits: params.row.no_of_units ? params.row.no_of_units : "",
                  buyingPrice: params.row.buying_quantity ? params.row.buying_quantity : "",
                  freeQuantity: params.row.free_quantity ? params.row.free_quantity : "",
                  discountPercentage: params.row.discount_percentage ? params.row.discount_percentage : "",
                  discountAmount: params.row.discount_amount ? params.row.discount_amount : "",
                  gstPercentage: params.row.gst_percentage ? params.row.gst_percentage : "",
                  mrp: params.row.mrp_quantity ? params.row.mrp_quantity : "",
                  expiryAlert: Expiry_period.find((list) => list?.value === params.row?.expiry_alert_period),
                  expiryDate: params.row.expiry_date ? params.row.expiry_date : "",
                  reorderThreshold: ProductData?.rol_quantity ? ProductData?.rol_quantity : "",
                  manufactureName: params.row.manufacturer_name ? params.row.manufacturer_name : "",
                  id: params.row.id ? params.row.id : null,
                  pi_line_item_id: params.row.pi_line_item_id ? params.row.pi_line_item_id : null,
                  physicalBoxNo: params.row.physical_box_no ? params.row.physical_box_no : "",
                })
                setpiLineEditID(params.row.pi_index)
                if (topDivRef.current) {
                  topDivRef.current.scrollTop = 0;
                  topDivRef.current.scrollTo({
                    top: 0,
                    behavior: "smooth"
                  });
                }
                setExpanded(true)
                setProductTab('product')
              }} />
              {
                (location?.states?.for_edit && params?.row?.id) ?
                  <Tooltip title={"Add new Batch"} placement="top" arrow>
                    <IconButton emed_tid={'Store_PI_Add_new_batch'} className='eMed_usrconf_btn' onClick={() => {
                      let ProductData = productList?.find((item) => item?.id === (params.row.productID || params.row.product_id))
                      setformData({
                        product_details: ProductData,
                        product_code: params.row?.product_code,
                        department_details: params.row?.department_name,
                        category_details: params.row?.category_name,
                        sub_category_details: params.row?.sub_category_name,
                        product_type_details: params.row?.product_type_name,
                        modelSerialNo: ProductData?.model_no ? ProductData?.model_no : "",
                        hsnCode: ProductData?.hsn_code ? ProductData?.hsn_code : "",
                        physicalBoxNo: "",
                        reorderThreshold: ProductData?.rol_quantity ? ProductData?.rol_quantity : "",
                        manufactureName: params.row.manufacturer_name ? params.row.manufacturer_name : "",
                        gstPercentage: params.row.gst_percentage ? params.row.gst_percentage : "",
                        batchNo: "",
                        quantity: "",
                        noOfUnits: "",
                        buyingPrice: "",
                        freeQuantity: "",
                        discountPercentage: "",
                        discountAmount: "",
                        mrp: "",
                        expiryAlert: "",
                        expiryDate: "",
                        id: null,
                        pi_line_item_id: params.row.pi_line_item_id ? params.row.pi_line_item_id : null,
                        new_batch: true,
                      })
                      setExpanded(true)
                      if (topDivRef.current) {
                        topDivRef.current.scrollTop = 0;
                        topDivRef.current.scrollTo({
                          top: 0,
                          behavior: "smooth"
                        });
                      }
                      setProductTab('product')
                    }}>
                      <img src={ImagePaths.AddIcon.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                    </IconButton>
                  </Tooltip> :
                  <CommonDeleteButton disable={params?.row?.from_stock} size="1.5vw" onClick={() => {
                    let CorrectIndex = StockItemData?.length ? params.api.getRowIndex(params.id) - StockItemData?.length : params.api.getRowIndex(params.id)
                    setSelectedDeleteIndex(CorrectIndex)
                  }} />
              }
            </Stack>}
        </Stack>)
    },
  ];

  useEffect(() => {
    getSubCategoryList()
    getCategoryList()
    getVendorList(location.states?.inward_details ? location.states?.inward_details?.vendor_id : null)
    getdepartmentList()
    getProductType()
    getProductList(location.states?.inward_details ? location.states?.inward_details?.vendor_id : null)
  }, [])


  useEffect(() => {
    setVendorFormData((prevData) => ({
      ...prevData,
      bill_amount: PurchaseInwardData.reduce((acc, vendor) => acc + (vendor.net_amount ? +vendor.net_amount : 0), 0),
      total_amount: PurchaseInwardData.reduce((acc, vendor) => acc + (vendor.taxable_amount ? +vendor.taxable_amount : 0), 0),
      cgst: PurchaseInwardData.reduce((acc, vendor) => acc + (vendor.gst_amount ? (+vendor.gst_amount) / 2 : 0), 0),
      sgst: PurchaseInwardData.reduce((acc, vendor) => acc + (vendor.gst_amount ? (+vendor.gst_amount) / 2 : 0), 0),
    }))
  }, [PurchaseInwardData]);

  useEffect(() => {
    const billAmount = +vendorFormData.bill_amount || 0;
    const paisaValue = +vendorFormData.paisa || 0;

    const roundOffValue = billAmount + (type_Paisa ? paisaValue / 100 : -paisaValue / 100);

    setVendorFormData(prev => ({
      ...prev,
      round_off: roundOffValue.toFixed(2),
    }));

  }, [vendorFormData.bill_amount, vendorFormData.paisa, type_Paisa]);

  useEffect(() => {
    if (productList?.length) {
      if (location.states?.inward_details) {
        setEditID(location.states?.inward_details?.id)
        setInwardId(location.states?.inward_details?.inward_id)
        getInwardDetails(location.states?.inward_details?.id)
      }
      if (location.states?.for_edit) {
        setVendorFormData((prevData) => ({
          ...prevData,
          bill_number: location.states?.bill_details ? location.states?.bill_details?.bill_number : prevData?.bill_number,
          bill_date: location.states?.bill_details ? location.states?.bill_details?.bill_date : prevData?.bill_date,
          tcs: location.states?.bill_details ? location.states?.bill_details?.tcs_amount : prevData?.tcs,
          delivery_date: location.states?.bill_details ? location.states?.bill_details?.delivery_date : prevData?.delivery_date,
        }))
        setOtherDetails(location.states?.inward_details?.other_details ? location.states?.inward_details?.other_details : "")
      }
    }
  }, [productList?.length > 0]);

  const msgClose = () => {
    seterrorMsg(false);
    seterrorMsgText('');
    setsuccessMsg(false);
    setsuccessMsgText('');
  }

  const closeDeletePop = () => {
    setSelectedDeleteIndex(null)
  }

  const deleteProduct = () => {
    let DataList = [...PurchaseInwardData]
    DataList.splice(selectedDeleteIndex, 1)
    setPurchaseInwardData(DataList)
    setSelectedDeleteIndex(null)
  }

  const errorMessage = (msg) => {
    setisloader(false)
    setPostBtnDisble(false)
    seterrorMsgText(msg)
    seterrorMsg(true)
  }
  const successMessage = (msg) => {
    setisloader(false)
    setPostBtnDisble(false)
    setsuccessMsgText(msg)
    setsuccessMsg(true)
  }

  const getCategoryList = () => {
    try {
      RestAPIService.getAll(Serviceurls.STORE_CATEGORY)
        .then((response) => {
          if (response.data.status === 'success') {
            setcategoryList(response.data.data?.filter((item) => item?.is_active) || [])
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getVendorList = (VendorId = null) => {
    try {
      RestAPIService.getAll(Serviceurls.STORE_VENDOR)
        .then((response) => {
          if (response.data.status === 'success') {
            setvendorList(response.data.data?.filter((item) => item?.is_active) || [])
            if (VendorId) {
              setVendorFormData((prev) => ({
                ...prev,
                vendor_details: response.data.data?.find((item) => item?.id === VendorId),
              }))
            }
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getdepartmentList = () => {
    try {
      RestAPIService.getAll(Serviceurls.STORE_DEPARTMENT)
        .then((response) => {
          if (response.data.status === 'success') {
            setdepartmentList(response.data.data?.filter((item) => item?.is_active) || [])
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getSubCategoryList = () => {
    try {
      RestAPIService.getAll(Serviceurls.STORE_SUB_CATEGORY)
        .then((response) => {
          if (response.data.status === 'success') {
            setsubCategoryList(response.data.data?.filter((item) => item?.is_active) || [])
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getProductType = () => {
    try {
      RestAPIService.getAll(Serviceurls.STORE_PRODUCT_TYPE)
        .then((response) => {
          if (response.data.status === 'success') {
            setProductTypeList(response.data.data?.filter((item) => item?.is_active) || [])
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getInwardDetails = (InwardId = null) => {
    try {
      let VendorBillId = location?.states?.bill_details?.vendor_bill_id ? location?.states?.bill_details?.vendor_bill_id : ""
      setisloader(true)
      RestAPIService.getAll(`${Serviceurls.STORE_PURCHASE_INWARD}?inward_id=${InwardId}&vendor_bill_id=${VendorBillId}`)
        .then((response) => {
          if (response.data.status === 'success') {
            let PiLineItems = response?.data?.data?.length ? response?.data?.data[0]?.pi_line_items : []
            let TableData = []
            PiLineItems?.forEach((list) => {
              let ProductDetails = productList?.find((item) => list?.product_id === item?.id)
              TableData?.push({
                product_id: ProductDetails?.id,
                product_name: ProductDetails?.product_name ? ProductDetails?.product_name : "",
                product_code: ProductDetails?.product_code ? ProductDetails?.product_code : "",
                product_details: ProductDetails,
                department_name: ProductDetails?.department_name ? ProductDetails?.department_name : "",
                category_name: ProductDetails?.category_name ? ProductDetails?.category_name : "",
                sub_category_name: ProductDetails?.sub_category_name ? ProductDetails?.sub_category_name : "",
                product_type_name: ProductDetails?.product_type_name ? ProductDetails?.product_type_name : "",
                modelSerialNo: ProductDetails?.model_no ? ProductDetails?.model_no : "",
                batch_no: "",
                hsn_code: ProductDetails?.hsn_code ? ProductDetails?.hsn_code : "",
                quantity: list?.quantity ? +list?.quantity : "",
                stock_in_quantity: (+list?.quantity && +list?.no_of_unit) ? (+list?.quantity * +list?.no_of_unit) : "",
                physical_box_no: "",
                no_of_units: "",
                free_quantity: "",
                buying_quantity: "",
                mrp_quantity: "",
                discount_amount: "",
                discount_percentage: "",
                gst_percentage: ProductDetails?.gst_percentage ? +ProductDetails?.gst_percentage : 0,
                gst_amount: 0,
                manufacturer_name: ProductDetails?.manufacturer_name ? ProductDetails?.manufacturer_name : "",
                expiry_date: "",
                expiry_alert_period: "",
                taxable_amount: 0,
                net_amount: 0,
                // id: list?.id ? list?.id : null,
                pi_line_item_id: list?.id ? list?.id : null,
              })
            })
            setPurchaseInwardData(TableData)
            let StockItems = response?.data?.data?.length ? response?.data?.data[0]?.stock_items : []
            let StockItemsData = []
            StockItems?.forEach((list) => {
              let ProductDetails = productList?.find((item) => list?.product_id === item?.id)
              const GSTAmount = (+list?.sgst_amount * 2) || 0
              const noOfUnits = +list?.no_of_units || 0;
              const buyingPrice = +list?.buying_price_per_unit || 1;
              const taxable_amount = noOfUnits ? (noOfUnits * buyingPrice) : 0;
              const net_amount = noOfUnits ? ((taxable_amount - (list?.discount_amount ? +list?.discount_amount : 0)) + GSTAmount) : 0;
              StockItemsData?.push({
                product_id: ProductDetails?.id,
                product_name: list?.product_name ? list?.product_name : "",
                product_code: list?.product_code ? list?.product_code : "",
                product_details: ProductDetails,
                department_name: list?.department_name ? list?.department_name : "",
                category_name: list?.category_name ? list?.category_name : "",
                sub_category_name: list?.sub_category_name ? list?.sub_category_name : "",
                product_type_name: list?.product_type_name ? list?.product_type_name : "",
                modelSerialNo: list?.model_no ? list?.model_no : "",
                batch_no: list?.batch_no ? list?.batch_no : "",
                hsn_code: list?.hsn_code ? list?.hsn_code : "",
                quantity: list?.quantity_per_unit ? +list?.quantity_per_unit : "",
                physical_box_no: list?.physical_box_no ? +list?.physical_box_no : "",
                no_of_units: list?.no_of_units ? +list?.no_of_units : "",
                stock_in_quantity: (+list?.quantity_per_unit && +list?.no_of_units) ? (+list?.quantity_per_unit * +list?.no_of_units) : "",
                free_quantity: list?.free_quantity ? +list?.free_quantity : "",
                buying_quantity: list?.buying_price_per_unit ? +list?.buying_price_per_unit : "",
                mrp_quantity: list?.mrp_per_unit ? +list?.mrp_per_unit : "",
                discount_amount: list?.discount_amount ? +list?.discount_amount : "",
                discount_percentage: list?.discount_percentage ? +list?.discount_percentage : "",
                gst_percentage: ProductDetails?.gst_percentage ? +ProductDetails?.gst_percentage : 0,
                gst_amount: list?.sgst_amount ? (+list?.sgst_amount * 2) : "",
                manufacturer_name: ProductDetails?.manufacturer_name ? ProductDetails?.manufacturer_name : "",
                expiry_date: list?.expiry_date ? list?.expiry_date : "",
                expiry_alert_period: list?.expiry_alert_period ? +list?.expiry_alert_period : "",
                taxable_amount: taxable_amount,
                net_amount: net_amount,
                id: list?.id ? list?.id : null,
                pi_line_item_id: list?.pi_line_item_id ? list?.pi_line_item_id : null,
                from_stock: VendorBillId ? false : true
              })
            })
            if (location.states?.for_edit) {
              setPurchaseInwardData(StockItemsData)
            } else {
              setStockItemData(StockItemsData)
            }
            setOtherDetails(response?.data?.data[0]?.other_details ? response?.data?.data[0]?.other_details : "")
            const inwardData = response?.data?.data?.[0]?.vendor_bills ? (response?.data?.data?.[0]?.vendor_bills[0] || {}) : {}
            const paiseAmount = inwardData?.paise_amount != null ? +inwardData.paise_amount : 0
            if (inwardData?.net_amount > 0 && !location?.states?.fromGRNEntry) {
              setType_Paisa(paiseAmount >= 0)
              setVendorFormData(prev => ({
                ...prev,
                paisa: Math.abs(paiseAmount)
              }))
            }
            setisloader(false)
          }
        }).catch(e => {
          setisloader(false)
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const getProductList = (VendorId = null) => {
    try {
      RestAPIService.getAll(Serviceurls.STORE_SUBLOC_PRODUCT_LIST + (VendorId ? `?vendor_id=${VendorId}` : ""))
        .then((response) => {
          if (response.data.status === 'success') {
            let List = (response.data?.data || [])
              .filter(item => item?.is_active)
              .map(item => ({
                ...item,
                display_key: `${item.product_name} | ${item.product_code} | ${item.department_name} | ${item.category_name} | ${item.sub_category_name} | ${item.product_type_name}`
              }));
            setProductList(List)
          }
        }).catch(e => {
          if (e?.response?.data?.status === 'fail') {
            errorMessage(e.response.data.message)
          } else {
            errorMessage(e.message)
          }
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const postPurchaseInward = (forFinish = false) => {
    try {
      if (!vendorFormData?.vendor_details) {
        errorMessage('Please Select Vendor')
      } else if (!vendorFormData?.bill_number) {
        errorMessage('Enter the Bill Number')
      } else if (!vendorFormData?.bill_date) {
        errorMessage('Select the Bill Date')
      } else if (!vendorFormData?.delivery_date) {
        errorMessage('Select the Delivery Date')
      } else if (PurchaseInwardData?.length === 0) {
        errorMessage('Please Add the Products')
      } else {
        let LineItems = []
        PurchaseInwardData?.forEach((list) => {
          if (list?.batch_no) {
            var date = new Date(list?.expiry_date);
            let expiry_date = DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
            let Obj = {
              'product_id': list?.product_details?.id,
              'pi_line_item_id': list?.pi_line_item_id ? list?.pi_line_item_id : null,
              'batch_no': list?.batch_no ? list?.batch_no : "",
              'expiry_date': list?.expiry_date ? expiry_date : null,
              'physical_box_no': list?.physical_box_no ? list?.physical_box_no : "",
              'hsn_code': list?.hsn_code ? list?.hsn_code : "",
              'expiry_alert_period': list?.expiry_alert_period ? list?.expiry_alert_period : 0,
              'manufacturer_name': list?.manufacturer_name,
              'quantity_per_unit': list?.quantity ? +list?.quantity : 0,
              'free_quantity': list?.free_quantity ? +list?.free_quantity : 0,
              'no_of_units': list?.no_of_units ? +list?.no_of_units : 0,
              'buying_price_per_unit': list?.buying_quantity ? +list?.buying_quantity : 0,
              'buying_price_per_quantity': list?.buying_quantity ? +(+list?.buying_quantity / (+list?.quantity ? +list?.quantity : 1)).toFixed(5) : 0,
              'mrp_per_unit': list?.mrp_quantity ? +list?.mrp_quantity.toFixed(2) : 0,
              'mrp_per_quantity': +(+list?.mrp_quantity / +list?.quantity).toFixed(2),
              'discount_percentage': list?.discount_percentage ? +list?.discount_percentage : 0,
              'discount_amount': list?.discount_amount ? +list?.discount_amount : 0,
              'cgst_percentage': list?.gst_percentage ? +(+list?.gst_percentage / 2).toFixed(2) : 0,
              'sgst_percentage': list?.gst_percentage ? +(+list?.gst_percentage / 2).toFixed(2) : 0,
              'cgst_amount': list?.gst_amount ? +(+list?.gst_amount / 2).toFixed(2) : 0,
              'sgst_amount': list?.gst_amount ? +(+list?.gst_amount / 2).toFixed(2) : 0,
              'stock_in_quantity': (+list?.quantity * +list?.no_of_units) + ((list?.free_quantity ? +list?.free_quantity : 0) * +list?.quantity)
            }
            if (location?.states?.for_edit && !list?.new_batch) {
              Obj['stock_id'] = (list?.id ? list?.id : null)
            }
            LineItems.push(Obj)
          }
        })
        const paisaValue = vendorFormData?.paisa ? +vendorFormData?.paisa : 0;
        const signedPaisa = type_Paisa ? paisaValue : -paisaValue;
        let data = {
          'inward_id': inwardId,
          'vendor_id': vendorFormData?.vendor_details?.id,
          'vendor_bill_number': vendorFormData?.bill_number,
          'bill_amount': +vendorFormData?.bill_amount,
          'cgst_amount': +vendorFormData?.cgst,
          'sgst_amount': +vendorFormData?.sgst,
          'tcs_amount': +vendorFormData?.tcs,
          'taxable_amount': vendorFormData?.total_amount ? +(vendorFormData?.total_amount?.toFixed(5)) : 0,
          'delivery_date': vendorFormData?.delivery_date ? DateTime.fromJSDate(new Date(vendorFormData.delivery_date)).toFormat('yyyy-MM-dd') : "",
          'bill_date': vendorFormData?.bill_date ? DateTime.fromJSDate(new Date(vendorFormData.delivery_date)).toFormat('yyyy-MM-dd') : "",
          'paise_amount': signedPaisa,
          'stock_items': LineItems,
          'other_details': otherDeatils,
          'from_direct_po': EditID ? false : true,
          'is_finish': forFinish ? true : false,
          'total_amount': +vendorFormData?.round_off,
        }
        if (location?.states?.for_edit) {
          if (EditID) {
            data["inward_id"] = EditID
            data["vendor_bill_id"] = location?.states?.bill_details?.vendor_bill_id ? location?.states?.bill_details?.vendor_bill_id : null
          }
          setisloader(true)
          RestAPIService.updateWithOutId(data, Serviceurls.STORE_PURCHASE_INWARD)
            .then((response) => {
              if (response.data.status === 'success') {
                setPostBtnDisble(false)
                setisloader(false)
                history.push({ pathname: "/StorePurchase/PurchaseInward", states: { success_message: response.data.message } })
              }
            }).catch(e => {
              if (e?.response?.data?.status === 'fail') {
                errorMessage(e.response.data.message)
              } else {
                errorMessage(e.message)
              }
            })
        } else {
          if (EditID) {
            data["inward_id"] = EditID
          }
          setisloader(true)
          RestAPIService.create(data, Serviceurls.STORE_PURCHASE_INWARD)
            .then((response) => {
              if (response.data.status === 'success') {
                setPostBtnDisble(false)
                setisloader(false)
                history.push({ pathname: "/StorePurchase/PurchaseInward", states: { success_message: response.data.message } })
              }
            }).catch(e => {
              if (e?.response?.data?.status === 'fail') {
                errorMessage(e.response.data.message)
              } else {
                errorMessage(e.message)
              }
            })
        }
      }
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const onChangeHandler = (event, name, maxLength, type) => {
    const {value} = event.target;
    const withinMaxLength = value?.length <= maxLength;
    switch (name) {
      case "discountPercentage":
        if (value === "" || (CommonValidation.DecimalNumber(value) && value >= 0 && value <= 100)) {
          setformData((prevData) => ({
            ...prevData,
            discountPercentage: value,
            discountAmount : value ? ((( +prevData.noOfUnits * +prevData.buyingPrice) * +value) / 100) : ""
          }))
        }
        break;
      case "discountAmount":
        if (value === "" || (CommonValidation.DecimalNumber(value) && value >= 0 && value <= (+formData.noOfUnits * +formData.buyingPrice))) {
          setformData((prevData) => ({
            ...prevData,
            discountAmount: value,
            discountPercentage : value ? +((+value / (+prevData.noOfUnits * +prevData.buyingPrice)) * 100)?.toFixed(2) :  ""
          }))
        }
      break;
      case "mrp":
        if (value === "" || (CommonValidation.NumberWithDot(value) && value >= 0)) {
          setformData((prevData) => ({
            ...prevData,
            mrp: value,
          }))
        }
        break;
      case "buyingPrice":
        if (value === "" || (CommonValidation.NumberWithDotThree(value) && value >= 0)) {
          setformData((prevData) => ({
            ...prevData,
            buyingPrice: value,
            discountAmount : "",
            discountPercentage : "",
          }))
        }
        break;
      default:
        if (type === "number") {
          if ((value === "" || (value && CommonValidation.numberOnly(value) && +value >= 0 && withinMaxLength))) {
            setformData((prevData) => ({
              ...prevData,
              [name]: value,
              discountAmount: ((name === "buyingPrice" || name === "noOfUnits")) ? "" : prevData?.discountAmount,
              discountPercentage: ((name === "buyingPrice" || name === "noOfUnits")) ? "" : prevData?.discountPercentage,
            }))
          }
        } else if (value === "" || (value && withinMaxLength)) {
          setformData((prevData) => ({
            ...prevData,
            [name]: value,
          }))
        }
        break;
    }
  };
  const onChangeHandlerVendor = (event, name, maxLength, type) => {
    if (maxLength >= event.target.value?.length && (event.target.value === "" || type !== "number" || (CommonValidation.numberOnly(event.target.value) && (+event.target.value >= 0)))) {
      setVendorFormData((prevData) => ({
        ...prevData,
        [name]: event.target.value,
      }));
    }
  };

  const onChangeHandlerAuto = (event, newvalue, name) => {
    switch (name) {
      case "product_details":
        setformData((prevData) => ({
          ...prevData,
          [name]: newvalue,
          department_details: newvalue?.department_name,
          category_details: newvalue?.category_name,
          sub_category_details: newvalue?.sub_category_name,
          product_type_details: newvalue?.product_type_name,
          modelSerialNo: newvalue?.model_no ? newvalue?.model_no : "",
          hsnCode: newvalue?.hsn_code ? newvalue?.hsn_code : "",
          gstPercentage: newvalue?.gst_percentage ? +newvalue?.gst_percentage : "",
          product_code: newvalue?.product_code ? newvalue?.product_code : "",
          reorderThreshold: newvalue?.rol_quantity ? +newvalue?.rol_quantity : "",
          manufactureName: newvalue?.manufacturer_name ? newvalue?.manufacturer_name : "",
        }))
        break;
      default: setformData((prevData) => ({
        ...prevData,
        [name]: newvalue,
      }))
        break;
    };
  };

  const onChangeHandlerAutoVendor = (event, newvalue, name) => {
    setVendorFormData((prevData) => ({
      ...prevData,
      [name]: newvalue,
    }));
    if (name === "vendor_details") {
      if (newvalue) {
        setProductList([])
        getProductList(newvalue?.id)
        setExpanded(true)
      } else {
        setExpanded(false)
      }
    }
  };


  const rendertable = () => {
    const updatedPurchaseInwardData = PurchaseInwardData.map((list, index) => ({
      ...list,
      pi_index: index
    }));
    [...StockItemData, ...updatedPurchaseInwardData]?.forEach((element, index) => element.sno = index + 1)
    return (
      <DataGrid
        rows={[...StockItemData, ...updatedPurchaseInwardData]}
        columns={columns}
        getRowId={(row) => row['sno']}
        rowHeight={80}
        disableSelectionOnClick
        hideFooter />)
  }

  const textBox = (label, name, val, type, disable = false, MaxLength = 30) => {
    return (
      <Box>
        <form autoComplete="off">
          <TextField
            size='small'
            // name={`${name}-store`}
            disabled={disable}
            value={val ? val : ""}
            id="drug-master"
            autoComplete="off"
            inputProps={{
              maxLength: MaxLength,
              autoComplete: 'new-password', // or 'off'
              form: {
                autoComplete: 'off',
              }
            }}
            sx={{ width: '14dvw', marginRight: '0.3vw' }}
            label={label}
            onChange={(e) => { onChangeHandler(e, name, MaxLength, type) }}
            variant="outlined"
          />
        </form>
      </Box>
    )
  }

  const datetextBox = (label, name, val, type, disable = false, MaxLength = 30) => {
    return (
      <Box>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={val ? val : null}
            name={"datePicker"}
            inputFormat={name === "expiryDate" ? 'MM-YYYY' : 'DD-MM-YYYY'}
            views={name === "expiryDate" ? ['year', 'month'] : ["year", "month", "day"]}
            onChange={(newDate) => {
              if (name === "expiryDate") {
                setformData((prevData) => ({
                  ...prevData,
                  [name]: newDate,
                }));
              } else {
                setVendorFormData((prevData) => ({
                  ...prevData,
                  [name]: newDate,
                }));
              }
            }}
            minDate={name === "bill_date" ? null : new Date()}
            maxDate={(name === "expiryDate" || name === "delivery_date") ? null : new Date()}
            disabled={disable}
            renderInput={(params) => <TextField
              {...params}
              label={label}
              name={name}
              variant="outlined"
              onKeyDown={(e) => e.preventDefault()}
              disabled={disable}
              sx={{ width: '14dvw', marginRight: '0.3vw' }}
              size='small'
            />}
          />
        </LocalizationProvider>
      </Box>
    )
  }
  const VendortextBox = (label, name, val, type, disable = false, MaxLength = 30) => {
    return (
      <Box>
        <TextField
          size='small'
          name={name}
          disabled={disable}
          inputProps={{ maxLength: MaxLength }}
          value={val ? val : ""}
          id="drug-master"
          // type={type}
          sx={{ width: '12.5dvw', marginRight: '0.3vw' }}
          label={label}
          onChange={(e) => { onChangeHandlerVendor(e, name, MaxLength, type) }}
          variant="outlined"
          InputProps={{
            endAdornment: name === "paisa" ?
              <InputAdornment sx={{ margin: "-2vw" }}>
                <IconButton
                  disabled={disable}
                  sx={{ width: "1.3vw", height: "1vw" }}
                  onClick={() => setType_Paisa(prev => !prev)}
                >
                  {type_Paisa ? (
                    <img src={ImagePaths.PlusIcon.default} alt="Plus" />
                  ) : (
                    <img src={ImagePaths.MinusIcon.default} alt="Minus" />
                  )}
                </IconButton>
              </InputAdornment> : null
          }}
        />
      </Box>
    )
  }

  const autoComplete = (label, name, val, list, option_key, disable = false) => {
    return (
      <Box>
        <Autocomplete
          size={'small'}
          options={list}
          name={name}
          disabled={disable}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option[option_key]}
          value={val}
          onChange={(event, newValue) => { onChangeHandlerAuto(event, newValue, name) }}
          renderInput={(params) => <TextField {...params} label={label} sx={{ width: name === "product_details" ? "29dvw" : "14dvw", marginRight: '0.3vw' }} disabled={disable} />}
          renderOption={(props, item) => {
            if (name === "product_details" && typeof (item) === 'object') {
              return (
                <Box {...props}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: "flex-start" }}>
                    <Box sx={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>{ContentInTooltip(item?.product_name, 30, "0.9vw", 600, "0.5vw")} - {ContentInTooltip(item?.product_code, 30, "0.9vw", 500, "0.5vw")} </Box>
                    <Box sx={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>{ContentInTooltip(item?.department_name, 30, "0.9vw", 500, "0.5vw")} - {ContentInTooltip(item?.category_name, 30, "0.9vw", 500, "0.5vw")} - {ContentInTooltip(item?.sub_category_name, 30, "0.9vw", 500, "0.3vw")}</Box>
                  </Box>
                </Box>
              );
            }
            return <li {...props}>{typeof (item) === 'string' ? item : item[option_key]}</li>;
          }}
        />
      </Box>
    )
  }

  const VendorautoComplete = (label, name, val, list, option_key, disable = false) => {
    return (
      <Box>
        <Autocomplete
          size={'small'}
          options={list}
          name={name}
          disabled={disable}
          getOptionLabel={(option) => option[option_key] || option}
          value={val}
          onChange={(event, newValue) => { onChangeHandlerAutoVendor(event, newValue, name) }}
          renderInput={(params) => <TextField {...params} label={label} sx={{ width: "25.27dvw", marginRight: '0.3vw' }} disabled={disable} />}
        />
      </Box>
    )
  }

  const setEditedData = (data) => {
    setOtherDetails(data);
  };

  const addProduct = () => {
    const noOfUnits = +formData?.noOfUnits || 1;
    const buyingPrice = +formData?.buyingPrice || 1;
    const taxable_amount = ((noOfUnits * buyingPrice) - (+formData?.discountAmount));
    let GSTAmount = CommonValidation.calculatePercentageWithoutRoundoff(+formData?.gstPercentage, taxable_amount)
    GSTAmount = GSTAmount ? GSTAmount : 0
    const net_amount = taxable_amount + GSTAmount;
    let PurchaseRequest = {
      pi_line_item_id: formData?.pi_line_item_id ? formData?.pi_line_item_id : null,
      id: (formData?.id && !formData?.new_batch) ? formData?.id : null,
      product_id: formData?.product_details?.id ? formData?.product_details?.id : null,
      product_name: formData?.product_details?.product_name ? formData?.product_details?.product_name : "",
      product_code: formData?.product_details?.product_code ? formData?.product_details?.product_code : "",
      product_details: formData?.product_details,
      department_name: formData?.department_details ? formData?.department_details : "",
      category_name: formData?.category_details ? formData?.category_details : "",
      sub_category_name: formData?.sub_category_details ? formData?.sub_category_details : "",
      product_type_name: formData?.product_type_details ? formData?.product_type_details : "",
      modelSerialNo: formData?.modelSerialNo ? formData?.modelSerialNo : "",
      batch_no: formData?.batchNo ? formData?.batchNo : "",
      hsn_code: formData?.hsnCode ? formData?.hsnCode : "",
      quantity: formData?.quantity ? +formData?.quantity : "",
      stock_in_quantity: (+formData?.quantity && +formData?.noOfUnits) ? (+formData?.quantity * +formData?.noOfUnits) : "",
      physical_box_no: formData?.physicalBoxNo ? formData?.physicalBoxNo : "",
      no_of_units: formData?.noOfUnits ? +formData?.noOfUnits : "",
      free_quantity: formData?.freeQuantity ? +formData?.freeQuantity : "",
      buying_quantity: formData?.buyingPrice ? +formData?.buyingPrice : "",
      mrp_quantity: formData?.mrp ? +formData?.mrp : "",
      discount_amount: formData?.discountAmount ? +formData?.discountAmount : "",
      discount_percentage: formData?.discountPercentage ? +formData?.discountPercentage : "",
      gst_percentage: formData?.gstPercentage ? +formData?.gstPercentage : 0,
      gst_amount: GSTAmount ? GSTAmount : 0,
      manufacturer_name: formData?.manufactureName,
      reorder_threshold: formData?.reorderThreshold,
      expiry_date: formData?.expiryDate,
      expiry_alert_period: formData?.expiryAlert?.value,
      taxable_amount: taxable_amount,
      net_amount: net_amount,
    }
    if (formData?.new_batch) {
      PurchaseRequest["new_batch"] = true
    }
    if (PiLineEditID !== null && !formData?.new_batch) {
      let DataList = [...PurchaseInwardData]
      DataList[PiLineEditID] = PurchaseRequest
      setPurchaseInwardData(DataList)
      setpiLineEditID(null)
    } else {
      let DataList = [...PurchaseInwardData, PurchaseRequest]
      setPurchaseInwardData(DataList)
      setpiLineEditID(null)
    }

    setVendorFormData(prev => ({
      ...prev,
      paisa: ""
    }));
    setType_Paisa(true);

    setformData({
      product_details: null,
      product_code: "",
      department_details: null,
      category_details: null,
      sub_category_details: null,
      product_type_details: null,
      modelSerialNo: "",
      hsnCode: "",
      batchNo: "",
      quantity: "",
      noOfUnits: "",
      stock_in_quantity: "",
      buyingPrice: "",
      freeQuantity: "",
      discountPercentage: "",
      discountAmount: "",
      gstPercentage: "",
      mrp: "",
      expiryAlert: null,
      expiryDate: null,
      reorderThreshold: "",
      manufactureName: "",
      physicalBoxNo: "",
    });
    setpiLineEditID(null)
  };

  return (
    <Box sx={{}}>
      <Box component={'div'} className='eMed_Pharma_Header_Card' sx={{ display: "flex", justifyContent: 'space-between', alignItems: 'center', height: "7dvh" }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton size="small" onClick={() => {
            history.push({ pathname: '/StorePurchase/PurchaseInward' })
          }} >
            <img className="emedhub_popupIcon_img" src={ImagePaths.LabBackButton.default} alt={"Back"} />
          </IconButton>
          <Typography sx={{ color: "#616161" }}> {"Back to Purchase Inward Home"}</Typography></Stack>
        <Box>
          {(location?.states?.for_edit && !location.states?.bill_details?.is_finished) ? <Button sx={{ textTransform: 'capitalize' }} size="small" disabled={postBtnDisble} variant="contained" onClick={() => { setPostBtnDisble('Finish Grn') }}>Finish GRN</Button> : null}
          {location.states?.bill_details?.is_finished ? null : <Button sx={{ textTransform: 'capitalize', marginLeft: "1vw" }} size="small" disabled={postBtnDisble} variant="contained" onClick={() => { setPostBtnDisble(true) }}>Generate GRN</Button>}
        </Box>
      </Box>
      {/* Vendor Details */}
      <Box sx={{ height: '78dvh', overflow: 'auto' }} ref={topDivRef}>
        <Box sx={{ marginBottom: "0.5vw" }}>
          <Typography fontSize={"1vw"} gutterBottom>
            Vendor Details
          </Typography>
          <Box sx={{ display: "flex", height: '6vw', flexWrap: 'wrap', alignItems: 'center' }}>
            {VendorautoComplete("Vendor", "vendor_details", vendorFormData.vendor_details, vendorList, "vendor_name", (location.states?.for_edit || PurchaseInwardData?.length > 0 || formData?.product_details !== null))}
            {datetextBox("Bill Date", "bill_date", vendorFormData.bill_date, "date", location.states?.for_edit)}
            {VendortextBox("Bill Number *", "bill_number", vendorFormData.bill_number, "text", location.states?.for_edit)}
            {datetextBox("Delivery Date", "delivery_date", vendorFormData.delivery_date, "date", location.states?.bill_details?.delivery_date)}
            {VendortextBox("Total Amount", "total_amount", (vendorFormData.total_amount ? +vendorFormData.total_amount?.toFixed(2) : 0), "number", true, 7)}
            {VendortextBox("CGST", "cgst", (vendorFormData.cgst ? +vendorFormData?.cgst?.toFixed(2) : 0), "number", true, 2)}
            {VendortextBox("SGST", "sgst", (vendorFormData.sgst ? +vendorFormData?.sgst?.toFixed(2) : 0), "number", true, 2)}
            {VendortextBox("TCS", "tcs", (vendorFormData.tcs ? vendorFormData?.tcs : 0), "number", false, 7)}
            {VendortextBox("Bill Amount", "bill_amount", (vendorFormData.bill_amount ? +vendorFormData.bill_amount.toFixed(2) : 0), "number", true, 7)}
            {VendortextBox("Paisa", "paisa", vendorFormData.paisa, "number", (location?.states?.inward_details?.status === 'Completely Delivered' || !vendorFormData.bill_amount), 2)}
            {VendortextBox("Round Off", "round_off", (vendorFormData.round_off || "0.00"), "number", true, 7)}
          </Box>
        </Box>
        {/* Product Details Accordion */}
        <Accordion expanded={expanded} disabled={vendorFormData?.vendor_details === null || (location?.states?.for_edit && location?.states?.inward_details?.status === 'Completely Delivered')} onChange={() => setExpanded(!expanded)}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Tabs
              value={productTab}
              onChange={(e, newValue) => {
                setProductTab(newValue)
              }}
            >
              <Tab value="product" label={"Product Details"} emed_tid='outOfOffice_tab' className='eMed_tab_header' />
              <Tab value="other" label={"Other Details"} emed_tid='history_tab' className='eMed_tab_header' />
            </Tabs>
          </AccordionSummary>
          <AccordionDetails>
            {
              productTab === "product" ?
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: 'wrap',
                      gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    {autoComplete("Search Product", "product_details", formData.product_details, productList, "display_key", ((formData?.new_batch || formData?.pi_line_item_id) ? true : false))}
                    {autoComplete("Department", "department_details", formData.department_details, departmentList, "department_name", true)}
                    {autoComplete("Category", "category_details", formData.category_details, categoryList, "category_name", true)}
                    {autoComplete("Sub Category", "sub_category_details", formData.sub_category_details, subCategoryList, "sub_category_name", true)}
                    {autoComplete("Product Type", "product_type_details", formData.product_type_details, productTypeList, "product_type_name", true)}
                    {textBox("Product Code", "product_code", formData.product_code, "text", true, 10)}
                    {textBox("Model/Serial No", "modelSerialNo", formData.modelSerialNo, "text", true, 30)}
                    {textBox("HSN Code", "hsnCode", formData.hsnCode, "text", true, 40)}
                    {textBox("Batch No *", "batchNo", formData.batchNo, "text", false, 50)}
                    {textBox("Quantity/unit *", "quantity", formData.quantity, "number", false, 6)}
                    {textBox("No Of Units *", "noOfUnits", formData.noOfUnits, "number", false, 7)}
                    {textBox("Buying Price/ Unit *", "buyingPrice", formData.buyingPrice, "text", false)}
                    {textBox("Free Quantity (units)", "freeQuantity", formData.freeQuantity, "number", false, 5)}
                    {textBox("Discount %", "discountPercentage", formData.discountPercentage, "text", false)}
                    {textBox("Discount Amount", "discountAmount", formData.discountAmount, "number", (!(formData.noOfUnits && formData.buyingPrice)), 7)}
                    {textBox("GST %", "gstPercentage", formData.gstPercentage, "number", true, 10)}
                    {textBox("MRP/Unit", "mrp", formData.mrp, "text", false)}
                    {autoComplete("Expiry Alert", "expiryAlert", formData.expiryAlert, Expiry_period, "label", false)}
                    {datetextBox((formData.product_details?.is_expiry ? "Expiry Date *" : "Expiry Date"), "expiryDate", formData.expiryDate, "date", false, 10)}
                    {textBox("Reorder Threshold", "reorderThreshold", formData.reorderThreshold, "number", true, 10)}
                    {textBox("Manufacture Name", "manufactureName", formData.manufactureName, "text", true, 30)}
                    {textBox("Physical Box No", "physicalBoxNo", formData.physicalBoxNo, "text", false, 15)}
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', }}>
                    <Button variant="outlined" sx={{ textTransform: 'capitalize', marginLeft: "1vw" }} size="small"
                      onClick={() => {
                        setpiLineEditID(null)
                        setformData({
                          product_details: null,
                          product_code: "",
                          department_details: null,
                          category_details: null,
                          sub_category_details: null,
                          product_type_details: null,
                          modelSerialNo: "",
                          hsnCode: "",
                          batchNo: "",
                          quantity: "",
                          noOfUnits: "",
                          stock_in_quantity: "",
                          buyingPrice: "",
                          freeQuantity: "",
                          discountPercentage: "",
                          discountAmount: "",
                          gstPercentage: "",
                          mrp: "",
                          expiryAlert: null,
                          expiryDate: null,
                          reorderThreshold: "",
                          manufactureName: "",
                          physicalBoxNo: "",
                        });
                      }}
                    >Clear</Button>
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ marginLeft: '1vw', textTransform: 'capitalize' }}
                      onClick={() => {
                        if (!formData?.product_details) {
                          errorMessage("Please, Select the Product")
                        } else if (!formData?.batchNo || !formData?.quantity || !formData?.buyingPrice || (!formData?.expiryDate && formData.product_details?.is_expiry) || !formData?.noOfUnits) {
                          errorMessage("Please, enter all mandatory feilds")
                        } else {
                          addProduct()
                        }
                      }}>Add</Button>
                  </Box>
                </Box> :
                <Box>
                  <ToolsFieldWithMic
                    Title={"Other Details"}
                    EditorRef={otherDeatils}
                    EditorDisable={false}
                    saveData={setEditedData}
                    minHeight={"12vh"}
                    overallHeight={"auto"}
                    isFrom="NoNeedButton"
                  />
                </Box>

            }
          </AccordionDetails>
        </Accordion>
        <Box sx={{ height: "100%", marginTop: "20px" }}>
          {rendertable()}
        </Box>
      </Box>
      {errorMsg ?
        <ToastMsg
          severity={'error'}
          msg={errorMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {successMsg ?
        <ToastMsg
          severity={'success'}
          msg={successMsgText}
          msgPop={msgClose.bind(this)}
        />
        : null}
      {isloader ? <Loader loaderOpen={isloader} /> : null}
      {selectedDeleteIndex !== null ?
        <DeletePopup
          DeletTitle={`Are you sure, Do you want to delete this product ?`}
          deleteAlertPopupClose={closeDeletePop.bind(this)}
          removeData={deleteProduct.bind(this)}
        />
        : null}
    </Box>
  );
};

export default StorePurchaseInwardAdd;
